import { ApprovalDialog } from "@/Workflow/Approval/ApprovalDialog";
import { EntityDialog, HtmlContentEditor, DataGrid } from "@serenity-is/corelib";
import { Config } from "@serenity-is/corelib/q";
import { SiteEntityDialog } from "./Base/SiteEntityDialog";
import { getLanguageList } from "./Helpers/LanguageList";
import "./SharedScriptTypes";
import "./Patches/ErrorHandling";
import "./Patches/ImageUploadEditorFix";
import "./Patches/RouterFix";
import "./Patches/RowSelectionFix";
import "./Patches/SlickItemLink";
import "./Patches/SubDialogHelperFix";
import "./Patches/UIOverrides";
import "@/Administration/User/Authentication/Authorization";
import Dialogs from "./Dialogs";

Config.responsiveDialogs = true;
Config.rootNamespaces.push('Matrix');
EntityDialog.defaultLanguageList = getLanguageList;
HtmlContentEditor.CKEditorBasePath = "~/Serenity.Assets/Scripts/ckeditor/";
DataGrid.defaultPersistanceStorage = window.localStorage;
SiteEntityDialog.ApprovalDialogClass = ApprovalDialog;

globalThis.Dialogs = Dialogs;